module.exports = __webpack_public_path__ + "img/download-file.78a9980b.png";